import { useSelectedBusiness } from "@/hooks/use-selected-business";
import { BuildingIcon, CalendarIcon, IdCardIcon } from "lucide-react";
import { format } from "date-fns";
import { getInitials } from "@/lib/utils";

// Format business ID as a client ID (YYYYMM-XXXXXX format)
function formatBusinessAsClientId(business: any): string {
  // Extract creation date or use current date
  const createdAt = business.createdAt ? new Date(business.createdAt) : new Date();
  
  // Get year and month for prefix
  const year = createdAt.getFullYear();
  const month = String(createdAt.getMonth() + 1).padStart(2, '0');
  
  // Use business ID padded with zeros for suffix
  const suffix = String(business.id).padStart(6, '0');
  
  // Combine as YYYYMM-XXXXXX
  return `${year}${month}-${suffix}`;
}

export function BusinessHeader() {
  const { activeBusiness } = useSelectedBusiness();

  if (!activeBusiness) {
    return null;
  }

  // Format business ID as client ID
  const clientId = formatBusinessAsClientId(activeBusiness);
  const displayName = activeBusiness.name || "Unnamed Business";

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-muted/50 border-b mb-4 overflow-hidden">
      <div className="flex items-center text-sm font-medium">
        <div className="w-6 h-6 bg-primary/10 rounded-full flex items-center justify-center text-primary text-xs font-bold mr-2">
          {getInitials(displayName)}
        </div>
        <div className="flex items-center">
          <span className="truncate text-foreground font-semibold mr-1.5">
            {displayName}
          </span>
          <span className="text-xs bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 px-1.5 py-0.5 rounded font-mono">
            {clientId}
          </span>
        </div>
        {/* Removed industry display entirely to avoid redundancy */}
      </div>
      
      <div className="flex items-center text-xs text-muted-foreground">
        <CalendarIcon className="w-3 h-3 mr-1" />
        <span>{format(new Date(), "MMMM d, yyyy")}</span>
      </div>

    </div>
  );
}